var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83276 0.166016C11.2522 0.166016 13.302 1.00545 14.9812 2.68457C16.6604 4.36374 17.4998 6.41356 17.4998 8.83301C17.4997 9.844 17.3374 10.7968 17.0125 11.6904C16.6875 12.584 16.2356 13.4005 15.658 14.1406L20.7498 19.2324L19.2332 20.749L14.1414 15.6572C13.4011 16.235 12.5839 16.6867 11.6902 17.0117C10.7965 17.3367 9.84378 17.499 8.83276 17.499C6.41352 17.4989 4.36436 16.6595 2.6853 14.9805C1.00626 13.3014 0.166823 11.2523 0.166748 8.83301C0.166748 6.41356 1.00614 4.36374 2.6853 2.68457C4.36434 1.00557 6.41357 0.166124 8.83276 0.166016ZM8.83276 2.33301C7.02745 2.33311 5.49301 2.9648 4.22925 4.22852C2.96536 5.4924 2.33276 7.02745 2.33276 8.83301C2.33284 10.6384 2.96548 12.1727 4.22925 13.4365C5.49303 14.7003 7.0274 15.3329 8.83276 15.333C10.6383 15.333 12.1734 14.7004 13.4373 13.4365C14.701 12.1727 15.3327 10.6384 15.3328 8.83301C15.3328 7.02745 14.7011 5.4924 13.4373 4.22852C12.1734 2.96467 10.6383 2.33301 8.83276 2.33301Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7b8e37654d5b71e6fcafd7f1a02256c9.svg";
export { ForwardRef as ReactComponent };